import React from 'react';

import './styles.scss';

const PageTitleCard = ({ className, title, icon, children }) => {
  return (
    <div className={`mb-4 page-title-card-container`}>
      <div className="d-flex justify-content-between">
        <div className={`page-title-card text-secondary ${className}`}>
          {icon} <span className="ms-2">{title}</span>
        </div>
        {children}
      </div>
    </div>
  );
};

export default PageTitleCard;
